import { cn } from '@/lib/utils';
import {
  StateMessage,
  type StateMessageProps,
  type StateMessageSize,
} from '@/components/common/StateMessage';

const PAGE_FILL_CLASS = 'min-h-[50dvh] flex-1';

const CARD_PADDING_CLASS: Record<StateMessageSize, string> = {
  default: 'px-6 py-12',
  compact: 'px-4 py-6',
};

interface StateCardProps extends StateMessageProps {
  fill?: boolean | undefined;
  className?: string | undefined;
}

export function StateCard({
  fill = false,
  className,
  size = 'default',
  ...message
}: StateCardProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-xl border bg-card',
        CARD_PADDING_CLASS[size],
        fill && PAGE_FILL_CLASS,
        className,
      )}
    >
      <StateMessage size={size} {...message} />
    </div>
  );
}
